import { Tabs as MuiTabs, TabsTypeMap } from "@mui/material";
import { styled } from "@mui/system";

export const Tabs = styled(MuiTabs)<TabsTypeMap["props"]>(({ theme }) => ({
  width: "100%",
  "& .MuiTab-root": {
    minWidth: "120px",
    padding: "0 10px",
    textTransform: "none",
    color: theme.palette.primary.main,
    fontSize: "14px",
    fontWeight: "400",
    height: "36px",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.secondary.main,
    height: "2px",
    borderRadius: "1px",
  },
  "& .Mui-selected": {
    color: `${theme.palette.secondary.main} !important`,
    fontWeight: "600",
  },
}));
